<template>
  <div class="right" v-if="loggedIn">
    <button v-if="estaImpersonando" class="btn-volver-impersonacion" @click="salirImpersonacion" title="Volver">
      <i class="fas fa-arrow-left"></i>
    </button>
    <div v-if="rolEfectivoId === 3" class="lang-switcher">
      <button class="lang-flag" :class="{ 'lang-active': $i18n.locale === 'es' }" @click="setLang('es')" title="Español">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14"><rect width="20" height="14" fill="#aa151b"/><rect y="3.5" width="20" height="7" fill="#f1bf00"/></svg>
      </button>
      <button class="lang-flag" :class="{ 'lang-active': $i18n.locale === 'en' }" @click="setLang('en')" title="English">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30"><rect width="60" height="30" fill="#012169"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" stroke-width="4"/><path d="M30,0 V30 M0,15 H60" stroke="#fff" stroke-width="10"/><path d="M30,0 V30 M0,15 H60" stroke="#C8102E" stroke-width="6"/></svg>
      </button>
    </div>
    <p class="estilo-trabajador">
      <i class="fa fa-user me-sm-1" aria-hidden="true"></i>
      {{ usuarioLabel }}
    </p>
    <a class="px-0 nav-link font-weight-bold text-body desconectar" @click="logoutUser">
      <i class="fa fa-power-off me-sm-1" aria-hidden="true"></i>
    </a>
  </div>

  <!-- No se muestra nada si no está autenticado -->
</template>

<script>
const ROLES = [
  { id: 1, nombre: "Administrador" },
  { id: 2, nombre: "Admin.Tipster" },
  { id: 3, nombre: "Cliente" },
  { id: 4, nombre: "Tipster" },
  { id: 5, nombre: "Publicista" },
];

export default {
  name: "NavUserMenu",

  computed: {
    loggedIn() {
      return this.$store.getters["auth/loggedIn"];
    },
    attrs() {
      return this.$store.state.auth?.me?.data?.attributes || {};
    },
    estaImpersonando() {
      return !!this.attrs.impersonando;
    },
    trabajadorTxt() {
      return (
        this.attrs.name ||
        this.attrs.username ||
        localStorage.getItem("usuarioNombre") ||
        "Invitado"
      );
    },
    rolEfectivoId() {
      const temporal = Number(this.attrs.rol_temporal ?? 0);
      const real     = Number(this.attrs.rol_real ?? this.attrs.rol_id ?? 0);
      return Number(this.attrs.rol_efectivo ?? (temporal || real));
    },
    rolNombre() {
      if (this.attrs.rol_name) return this.attrs.rol_name;
      const encontrado = ROLES.find((r) => r.id === this.rolEfectivoId);
      const loading = !!this.$store.state.auth?.meLoading;
      return encontrado?.nombre || (loading ? "Cargando..." : "Sin rol");
    },
    usuarioLabel() {
      return `${this.trabajadorTxt} (${this.rolNombre})`;
    },
  },

  methods: {
    async salirImpersonacion() {
      await this.$store.dispatch("auth/clearRolTemporal");
    },
    setLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('quanty_lang', lang);
    },
    async logoutUser() {
      try {
        await this.$store.dispatch("auth/logout");
        ["usuarioEmail", "usuarioNombre", "usuarioRolId", "usuarioTipsterId", "rolTemporalId"]
          .forEach((k) => localStorage.removeItem(k));
      } finally {
        this.$router.push("/login");
      }
    },
    loginUser() {
      this.$store.commit("abrirLoginModal");
    },
  },
};
</script>

<style scoped>
.btn-volver-impersonacion {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border: 1.5px solid var(--q-amber, #f59e0b);
  border-radius: 20px;
  background: transparent;
  color: var(--q-amber, #f59e0b);
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
}
.btn-volver-impersonacion:hover {
  background: rgba(245,158,11,0.12);
}
.lang-switcher {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-right: 4px;
}
.lang-flag {
  background: none;
  border: 1.5px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  padding: 2px 3px;
  line-height: 1;
  opacity: 0.6;
  display: inline-flex;
  align-items: center;
  transition: opacity 0.15s, border-color 0.15s;
}
.lang-flag svg {
  width: 22px;
  height: auto;
  border-radius: 2px;
  display: block;
}
.lang-flag:hover { opacity: 1; }
.lang-flag.lang-active { opacity: 1; border-color: var(--q-gold); }
</style>
